import { Component, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
<div *ngIf="form">
  <form [formGroup]="form">
    <se-po-suffix-select
      formControlName="suffix"
      seFeDataLabel="Suffix">
    </se-po-suffix-select>
  </form>
</div>
<div class="form-value">
  <code>
    {{ form.value | json }}
  </code>
</div>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'

export class SuffixSelectDocsComponent implements OnInit {
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder
  ) {}

  public ngOnInit(): void {
    this.form = this.fb.group({
      suffix: ['']
    })
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-suffix-select-example',
  template,
  styleUrls: ['./suffix-select-docs.component.scss'],
  standalone: false,
})
export class SuffixSelectExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder
  ) {
    super()
  }

  public ngOnInit(): void {
    this.form = this.fb.group({
      suffix: ['']
    })
  }
}
